<template>
    <div class="tw-flex tw-items-center tw-gap-5 tw-flex-wrap">
        <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" class="tw-shrink-0">
            <circle :cx="c" :cy="c" :r="r" fill="none" stroke="#eceaf2" :stroke-width="thickness" />
            <circle v-for="(seg, i) in segments" :key="i"
                :cx="c" :cy="c" :r="r" fill="none" :stroke="seg.color" :stroke-width="thickness"
                :stroke-dasharray="`${seg.len} ${circumference - seg.len}`" :stroke-dashoffset="seg.offset"
                stroke-linecap="round"
                :transform="`rotate(-90 ${c} ${c})`"
                class="tw-duration-300" />
            <text :x="c" :y="c - 4" text-anchor="middle" fill="#1f2937" font-size="22" font-weight="700">{{ total }}</text>
            <text :x="c" :y="c + 14" text-anchor="middle" fill="#9ca3af" font-size="10">{{ centerLabel }}</text>
        </svg>

        <div class="tw-space-y-2">
            <div v-for="(seg, i) in segments" :key="'l' + i" class="tw-flex tw-items-center tw-gap-2 tw-text-sm">
                <span class="tw-w-2.5 tw-h-2.5 tw-rounded-full" :style="{ background: seg.color }"></span>
                <span class="tw-text-gray-600 tw-capitalize">{{ seg.label }}</span>
                <span class="tw-font-semibold tw-text-gray-800 tw-ml-1">{{ seg.value }}</span>
                <span class="tw-text-gray-400 tw-text-xs">({{ total ? Math.round((seg.value / total) * 100) : 0 }}%)</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
    data: { type: Array, default: () => [] }, // [{ label, value, color }]
    size: { type: Number, default: 150 },
    thickness: { type: Number, default: 20 },
    centerLabel: { type: String, default: '' },
});

const c = computed(() => props.size / 2);
const r = computed(() => props.size / 2 - props.thickness / 2 - 2);
const circumference = computed(() => 2 * Math.PI * r.value);
const total = computed(() => props.data.reduce((a, d) => a + (d.value || 0), 0));

const segments = computed(() => {
    let acc = 0;
    return props.data.map((d) => {
        const frac = total.value ? d.value / total.value : 0;
        const len = frac * circumference.value;
        const offset = -acc;
        acc += len;
        return { ...d, len, offset };
    });
});
</script>
